<template>
  <v-app id="inspire">
    <router-view></router-view>

    <v-snackbar
      v-model="getSnackbar.snackbar"
      :color="getSnackbar.color"
      :timeout="getSnackbar.timeout"
      :bottom="getSnackbar.bottom"
      :left="getSnackbar.left"
      :multi-line="getSnackbar.multiline"
      :right="getSnackbar.right"
      :top="getSnackbar.top"
      :vertical="getSnackbar.vertical"
      class="mt-0"
    >
      <div style="font-size: 13px; margin-bottom: 1px"> {{ getSnackbar.msg }} </div>
      <v-btn
        style="margin-bottom: 1px"
        height="20px"
        dark
        text
        small
        @click="$store.state.global.snackbar = false"
      ><v-icon class="mr-2">mdi-close-circle</v-icon>
        Fechar
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('global', ['getSnackbar'])
  },
  methods: {
    ...mapMutations({
      setConfirm: 'global/setConfirm',
      setSnackbar: 'global/setSnackbar'
    })
  },
  mounted () {
    console.log('Iniciado...')
    // window.localStorage.setItem('fingerprint_data', new Date())
    const stringDataFinger = window.localStorage.getItem('fingerprint_data')
    if ((stringDataFinger === undefined) || (stringDataFinger === null)) {
      console.log('Sem o fingerprint_data')
      window.localStorage.setItem('fingerprint_data', new Date())
    } else {
      const dataFinger = new Date(stringDataFinger)
      const dataAtual = new Date()
      const tempoDecorrido = dataAtual.getTime() - dataFinger.getTime()
      console.log('Tempo: ', tempoDecorrido)
      const tempoRenovacao = 86400000 * 7 // 7
      // const tempoRenovacao = 1000 // pegar no console pra fazer testes
      if (tempoDecorrido > tempoRenovacao) {
        console.log('Fingerprint vencido')
        window.localStorage.removeItem('fingerprint')
        window.localStorage.removeItem('userInfo')
        window.localStorage.removeItem('fingerprintData')
        window.localStorage.removeItem('fingerprint_data')
        window.localStorage.setItem('fingerprint_data', new Date())
        // window.localStorage.clear()
        location.reload(true)
      } else {
        console.log('Fingerprint ok')
      }
    }
  }
}
</script>

<style>
.v-date-picker-table {
  height: 255px !important;
}
</style>

<style lang="scss">
@import '@/sass/variables.scss';

.custom-class {
  border-radius: $border-radius-root;
}
</style>
